/* eslint-disable no-nested-ternary */
import { useGroupWinnersWC26, useWC26ScoringRules, useWC26UserTeams } from '../../queries';
import Spinner from '../Spinner/Spinner';
import GroupWinnerCardWC26 from './GroupWinnerCardWC26';
import './GroupWinnersWC26.css';

function GroupWinnersWC26() {
  const [groupWinnersLoading, groupWinners, groupWinnersError] = useGroupWinnersWC26();
  const [rulesLoading, rules, rulesError] = useWC26ScoringRules();
  const [userTeamsLoading, userTeams, userTeamsError] = useWC26UserTeams();

  const loading = groupWinnersLoading || rulesLoading || userTeamsLoading;
  const error = groupWinnersError || rulesError || userTeamsError;
  const filteredGroupWinners = groupWinners?.filter((w) => w.group !== 'Group Stage');

  return (
    <div className="group-winners-wc26">
      <h2 className="group-winners-wc26__title">Group Winners</h2>
      {error ? <p className="group-winners-wc26-empty">Failed to load data.</p>
        : loading ? <Spinner />
          : !filteredGroupWinners || filteredGroupWinners.length === 0 || !rules || !userTeams
            ? <p className="group-winners-wc26-empty">No data yet</p>
            : (
              <div className="group-winners-wc26-grid">
                {filteredGroupWinners.map((winner) => (
                  <GroupWinnerCardWC26
                    key={winner.group}
                    groupWinner={winner}
                    scoringRules={rules}
                    teamAllocs={userTeams}
                  />
                ))}
              </div>
            )}
    </div>
  );
}

export default GroupWinnersWC26;
